import React from 'react'
import { I18n } from 'react-redux-i18n'
import { FaFacebookOfficial, FaInstagram, FaYoutubePlay } from 'react-icons/lib/fa'
import { Translate } from 'react-redux-i18n'

import './style.css'
const Footer = () => (
  <footer>
    <div className="copyright">
      <div>
        <div className="contact"><Translate value="contact_support" />：<a href="mailto:support@intocaerulus.com" target="_blank" rel="noopener noreferrer">support@intocaerulus.com</a></div>
        Copyright &copy; Caerulus Vision Co., Ltd.
      </div>
      <div className="policy">
        <a className="item link" href="https://caerulusvision.com" target="_blank" rel="noopener noreferrer">{I18n.t('about')}</a>
        <a className="item link" href="/privacy" target="_blank" rel="noopener noreferrer">{I18n.t('privacy')}</a>
        <a className="item link" href="/terms" target="_blank" rel="noopener noreferrer">{I18n.t('terms')}</a>
        <a className="item icon fb" href="https://www.facebook.com/intoCaerulus/" target="_blank" rel="noopener noreferrer"><FaFacebookOfficial size={20} /></a>
        <a className="item icon ig" href="https://www.instagram.com/into_caerulus/" target="_blank" rel="noopener noreferrer"><FaInstagram size={20} /></a>
        <a className="item icon yt" href="https://www.youtube.com/channel/UC7vY6HuIuMMPJtUBkOkGirA" target="_blank" rel="noopener noreferrer"><FaYoutubePlay size={20} /></a>
      </div>
    </div>
  </footer>
)
export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/index.js